import React, { Fragment, memo } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import IconYellowAlert from "~/components/Icons/alert-square";
import IconRedAlert from "~/components/Icons/alert-triangle";
import Preloader from "~/components/Preloader";
import Wrapper from "~/shared/ui/Wrapper";
import { getFormatDate } from "~/libs/getFormatDate";
import { IconMimeType } from "~/libs/resolveMemeType";
import {
  Document,
  File,
  useGetDocumentQuery,
} from "~/schemas/generated/graphql";

import { DOCUMENT_VIEWING } from "./options";

import s from "./DocumentViewing.less";

type Params = {
  id: string;
};

const DocumentView = () => {
  const { t } = useTranslation();
  const { id } = useParams<Params>();
  const history = useHistory();

  const { data, loading } = useGetDocumentQuery({
    variables: { id },
    fetchPolicy: "no-cache",
  });

  const documentInstance = get(data, "DocumentGetter.getOne") as
    | Document
    | undefined;

  if (loading || !documentInstance) return <Preloader />;

  const { Section, createdAt, updatedAt } = documentInstance;

  const goBack = () =>
    history.replace(`/documents/documents_in_catalog/${Section.id}/`);

  const categoryIco = () => {
    switch (documentInstance.importance) {
      case "urgent":
        return <IconRedAlert />;
      case "important":
        return <IconYellowAlert />;
    }
  };

  return (
    <Wrapper.Content
      title={`${t("documents.document")}: ${documentInstance.name}`}
      goBackHandler={goBack}
      txtBtn={'Назад'}
    >
      <div className={s.wrapper}>
        <div className={s.wrapper_right}>
          {DOCUMENT_VIEWING.map((option, index) => (
            <Fragment key={index}>
              <DataLine
                title={t(`documents.card.${option}`)}
                data={documentInstance[option]}
              />
            </Fragment>
          ))}
        </div>
        <div className={s.wrapper_left}>
          <div className={s.wrapper_left__content}>
            <div className={s.info__text}>
              <div className={s.fixDeadline}>
                {t("documents.dateCreated")}:{" "}
                <span>{getFormatDate(createdAt)}</span>
              </div>
              <div className={s.fixDeadline}>
                {t("documents.dateUpdated")}:{" "}
                <span>{getFormatDate(updatedAt)}</span>
              </div>
            </div>
            {categoryIco()}
          </div>
        </div>
      </div>
    </Wrapper.Content>
  );
};

export default memo(DocumentView);

interface IDataLine {
  title: string;
  data: unknown;
}

const DataLine = ({ title, data }: IDataLine) => {
  if (typeof data === "object" && Array.isArray(data)) {
    return (
      <div className={s.item}>
        <label className={s.item_title}>{title}</label>
        <div className={s.item_description}>
          {(data as File[]).map((file) => (
            <span key={file.id} className={s.cont}>
              <a
                href={file.link}
                download
                target="_blank"
                placeholder={file.name}
                rel="noreferrer"
              >
                {IconMimeType(file)}
              </a>{" "}
            </span>
          ))}
        </div>
      </div>
    );
  }
  if (typeof data === "string") {
    return (
      <div className={s.item}>
        <label className={s.item_title}>{title}</label>
        <div className={s.item_description}>{data}</div>
      </div>
    );
  }

  return <></>;
};
